import styled, { css } from 'styled-components';
import { styles, mixins } from '4all-ui/styles';
import { container } from '../../../styles/mixins';
import { Box } from '../../../styles/customComponents';
import IconSearch from '../../../images/icon-search.svg';

export const Container = styled.div`
  ${container()}
  margin-bottom: 20px;
  margin-top: 31px;
`;

export const Content = styled.div`
  ${mixins.flexPosition({ align: 'center' })}
`;

export const BoxAction = styled(Box)`
  padding: 22px 30px 25px;

  label {
    ${mixins.fontStyle(
      styles.colors.GRAY_DARKER,
      styles.fontSizes.SIZE_5,
      styles.fontWeights.NORMAL
    )}
    line-height: 24px;
    margin-bottom: 14px;
  }
`;

export const CreateCategory = styled(BoxAction)`
  ${mixins.flexPosition({ align: 'center' })}
  flex-shrink: 0;
  margin-right: 23px;
  width: 457px;

  form {
    ${mixins.flexPosition({ align: 'center', justify: 'space-between' })}
  }
`;

export const SearchProduct = styled(BoxAction)`
  width: 100%;

  input {
    ${props =>
      props['show-search-icon'] &&
      css`
        background-image: url(${IconSearch});
        background-repeat: no-repeat;
        background-origin: content-box;
        background-position: right;
      `};
  }
`;

export const DivSearchInput = styled.div`
  ${mixins.flexPosition({ align: 'center' })}
  position: relative;

  svg {
    cursor: pointer;
  }
`;

export const CloseContainer = styled.button`
  background-color: transparent;
  border: none;
  height: 17px;
  padding: 0px;
  position: absolute;
  right: 10px;
`;



// WEBPACK FOOTER //
// ./src/screens/Product/ProductsSecondaryActions/style.js